let chartProperties = (function () {

    const t = {};

    let chartDataSetColors = Object.values(CHART_COLORS);
    let backgroundColor = '#fff';
    let legendPosition = 'right';
    let suggestedMax = 4;
    t.labelValueType = 'counter';
    t.chartType = 'Bar';
    t.chartTitle = '';

    let basicSetOptions = {
        fill: false,
        hidden: true,
        backgroundColor: '',
        borderColor: '',
    };

    let xAxes = {
        gridLines: {
            display: false
        },
        ticks: {
            autoSkip: false
        }
    };

    let yAxes = {
        ticks: {
            beginAtZero: true,
            suggestedMax: suggestedMax,
        }
    };

    let chartBasicOptions = {
        chartArea: {
            backgroundColor: backgroundColor
        },
        title: {
            display: false,
            text: t.chartTitle
        },
        legend: {
            position: legendPosition,
            labels: {}
        },
        scaleShowValues: true,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            xAxes: [xAxes],
            yAxes: [yAxes]
        }
    };

    let timeToolTipOptions = {
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';

                    if (label) {
                        label += ': ';
                    }
                    let yValue = tooltipItem.yLabel;

                    let minutes = Math.floor(yValue);

                    let hours = Math.floor(minutes / 60)

                    minutes = minutes - (hours * 60);

                    let seconds = Math.floor((tooltipItem.yLabel % 1) * 60);

                    if (seconds < 10) {
                        seconds = '0' + seconds;
                    }

                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }

                    if (hours < 10) {
                        hours = '0' + hours;
                    }

                    let format = hours + ':' + minutes + ':' + seconds;

                    label += format;
                    return label;
                }
            }
        }
    };

    /**
     * Get tooltipOptions for y-Axis timer values
     *
     * @returns Object
     */
    t.getTimeToolTipOptions = () => {
        return timeToolTipOptions;
    };

    /**
     * Setter for chartType
     *
     * @param chartType
     */
    t.setChartType = (chartType) => {
        t.chartType = chartType;
    };

    /**
     * Set the type of value for the Y-axis (timer/counter)
     *
     * @param valueType
     */
    t.setLabelValueType = (valueType) => {
        t.labelValueType = valueType;
    };

    /**
     * Set the title of the chart
     *
     * @param title
     */
    t.setChartTitle = (title) => {
        t.chartTitle = title;
    };

    /**
     * Build Chart options based on variables
     *
     * @returns {*}
     */
    t.buildChartOptions = () => {
        let options = {};

        switch (t.chartType) {
            case 'Line':
                options = t.getLineChartOptions();
                break;
            case 'Bar' :
                options = t.getBarChartOptions();
                break;
            default:
        }
        return options;
    };


    /**
     * Method to add chart option specific for time y-axis values
     *
     * @returns Object
     */
    t.addTimeValuesSpecificOptions = function (options) {
        let toolTipOptions = t.getTimeToolTipOptions();
        let yAxisOptions = options['scales']['yAxes'].shift();

        yAxisOptions['ticks']['callback'] = function (value) {
            if (value % 1 === 0) {
                return value;
            }
        };

        yAxisOptions['ticks']['suggestedMax'] = 2;
        options['scales']['yAxes'].push(yAxisOptions);

        return Object.assign({}, options, toolTipOptions);
    };

    /**
     * Method to add chart option specific for count y-axis values
     *
     * @returns Object
     */
    t.addCountValuesSpecificOptions = function (options) {

        let yAxisOptions = options['scales']['yAxes'].shift();

        yAxisOptions['ticks']['callback'] = function (value) {
            if (value % 1 === 0) {
                return value;
            }
        };
        yAxisOptions['ticks']['suggestedMax'] = 4;
        options['scales']['yAxes'].push(yAxisOptions);

        return Object.assign({}, options);
    };


    /**
     * Method to customize chart options for bar chart
     *
     * @returns Object
     */
    t.getBarChartOptions = () => {

        let basicOptions = Object.assign({}, chartBasicOptions);
        let barChartOptions = t.addYAxisLabelSpecificOptions(basicOptions);

        return barChartOptions;

    };

    /**
     * Method to customize chart options for line chart
     *
     * @returns Object
     */
    t.getLineChartOptions = () => {

        let basicOptions = Object.assign({}, chartBasicOptions);
        let lineChartOptions = t.addYAxisLabelSpecificOptions(basicOptions);
        return lineChartOptions;
    };

    /**
     *  Get Basic options for a dataset
     *
     * @param setNumber
     * @returns Object
     */
    t.getBasicSetOptions = function (setNumber) {

        let setOptions = Object.assign({}, basicSetOptions);
        setOptions.backgroundColor = chartDataSetColors[setNumber];
        setOptions.borderColor = chartDataSetColors[setNumber];

        return setOptions;
    };

    /**
     * Setter for properties object of X-Axis
     *
     * @param xAxisPropertiesObject
     */
    t.setXAxisProperties = (xAxisPropertiesObject) => {
        this.xAxes = xAxisPropertiesObject;
    };

    /**
     * Setter for properties object Y-Axis
     *
     * @param yAxisPropertiesObject
     */
    t.setYAxisProperties = (yAxisPropertiesObject) => {
        this.yAxes = yAxisPropertiesObject;
    };


    /**
     * Method to add options to chart based on Y-axis value type.
     *
     * @param options
     * @returns {*}
     */
    t.addYAxisLabelSpecificOptions = function (options) {

        switch (t.labelValueType) {
            case 'timer':
                options = t.addTimeValuesSpecificOptions(options);
                break;
            case 'counter':
                options = t.addCountValuesSpecificOptions(options);
                break;
            default:
        }
        return options;
    };


    /**
     * Constructor
     */
    (function () {
    })();

    return t;
})();